{
    "name": "Common Hop",
    "binomial_name": "Humulus lupulus",
    "common_names": [
        "common hop"
    ],
    "description": "",
    "sun_requirements": "",
    "sowing_method": "",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/hop.jpg",
    "icon": "/crops/icons/hop.avif"
}